export enum LayoutOptionType {
  default_layout = "default_layout",
  custom_layout = "custom_layout",
  all = "all",
}

export interface LayoutOption {
  value: LayoutOptionType;
  label: string;
}